import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.');
        const envApiUrl = process.env.REACT_APP_API_URL?.trim();
        const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';
        const res = await fetch(`${API_URL}/settings/global`);
        const json = await res.json();
        if (json.success && json.data) {
          setSettings(json.data);
        }
      } catch (err) {
        console.error('Failed to load global settings in footer:', err);
      }
    };
    fetchSettings();
  }, []);

  const businessName = settings?.businessName || 'Kisan Tradecom Private Limited';
  const supportPhone = settings?.supportPhone || '+91 96312 77264';
  const supportEmail = settings?.supportEmail || 'ktpldsbsales@gmail.com';
  const sparesEmail = settings?.sparesEmail || 'ktpldsbspares@gmail.com';
  const whatsappNo = settings?.whatsappNumber?.replace(/[^0-9]/g, '') || '919631277264';
  const officeAddress = settings?.officeAddress;

  const facebookUrl = settings?.socialLinks?.facebook || 'https://www.facebook.com/share/18qJ5U9PYE/';
  const instagramUrl = settings?.socialLinks?.instagram || 'https://www.instagram.com/kisanengineeringworks1?igsh=MW11YTJ2aDE1endzeQ==';
  const youtubeUrl = settings?.socialLinks?.youtube || 'https://youtube.com/@kisanengineeringworks1?si=spWrGg-fYZBqb8Q_';

  return (
    <footer className="main-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col brand-col">
            <p className="footer-tagline">{t('footer.tagline')}</p>
            <div className="id-badges">
              <div className="id-badge">
                <span className="label">{t('footer.cin')}</span>
                <span className="value">U52100BR2010PTC053133</span>
              </div>
              <div className="id-badge">
                <span className="label">{t('footer.gstn')}</span>
                <span className="value">{settings?.gstin || '10AADCK9385N1Z3'}</span>
              </div>
            </div>
          </div>

          <div className="footer-col">
            <h3 className="col-title">{t('footer.quick_links')}</h3>
            <ul className="footer-links">
              <li><Link to="/products">{t('nav.products')}</Link></li>
              <li><Link to="/dealer-locator">{t('nav.dealer_locator')}</Link></li>
              <li><Link to="/gallery">{t('footer.gallery')}</Link></li>
              <li><Link to="/news">{t('footer.news')}</Link></li>
              <li><Link to="/testimonials">{t('footer.farmer_testimonials')}</Link></li>
              <li><Link to="/service">{t('footer.service_centers')}</Link></li>
              <li><Link to="/music-video">{t('footer.brand_song', 'Brand Song')}</Link></li>
            </ul>
          </div>


          <div className="footer-col">
            <h3 className="col-title">{t('footer.contact_us')}</h3>
            <ul className="contact-list">
              <li className="yellow-text">
                <a href={`tel:${supportPhone}`} className="contact-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                  {supportPhone}
                </a>
              </li>
              <li className="yellow-text">
                <a href={`mailto:${supportEmail}`} className="contact-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                  {supportEmail}
                </a>
              </li>
              <li className="yellow-text">
                <a href={`mailto:${sparesEmail}`} className="contact-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                  {sparesEmail}
                </a>
              </li>
              <li className="whatsapp-link" onClick={() => window.open(`https://wa.me/${whatsappNo}`, '_blank')} style={{ cursor: 'pointer' }}>
                <a href={`https://wa.me/${whatsappNo}?text=Hello%20Kisaan%20Maan,%20I%20have%20an%20enquiry.`} target="_blank" rel="noopener noreferrer" className="contact-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/></svg>
                  {t('footer.whatsapp_us')}
                </a>
              </li>
              <li className="whatsapp-link" onClick={() => window.open('https://whatsapp.com/channel/0029VbCMOVlEquiObsmwRB12', '_blank')} style={{ cursor: 'pointer' }}>
                <a href="https://whatsapp.com/channel/0029VbCMOVlEquiObsmwRB12" target="_blank" rel="noopener noreferrer" className="contact-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/></svg>
                  {t('footer.whatsapp_channel')}
                </a>
              </li>
            </ul>
            <div className="footer-social-links">
              <a href={instagramUrl} className="footer-social-item instagram" target="_blank" rel="noopener noreferrer" title="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href={facebookUrl} className="footer-social-item facebook" target="_blank" rel="noopener noreferrer" title="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href={youtubeUrl} className="footer-social-item youtube" target="_blank" rel="noopener noreferrer" title="YouTube">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95 1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"></path>
                  <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"></polygon>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-col location-col">
            <h3 className="col-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                <path d="M16.6587 8.32948C16.6587 12.4883 12.0451 16.8196 10.4958 18.1573C10.3515 18.2658 10.1758 18.3245 9.99525 18.3245C9.81468 18.3245 9.63899 18.2658 9.49466 18.1573C7.9454 16.8196 3.33179 12.4883 3.33179 8.32948C3.33179 6.56222 4.03383 4.86734 5.28347 3.6177C6.53311 2.36806 8.22799 1.66602 9.99525 1.66602C11.7625 1.66602 13.4574 2.36806 14.707 3.6177C15.9567 4.86734 16.6587 6.56222 16.6587 8.32948Z" stroke="#4BA83D" strokeWidth="1.66587" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9.99514 10.8282C11.3752 10.8282 12.4939 9.70942 12.4939 8.32937C12.4939 6.94932 11.3752 5.83057 9.99514 5.83057C8.61509 5.83057 7.49634 6.94932 7.49634 8.32937C7.49634 9.70942 8.61509 10.8282 9.99514 10.8282Z" stroke="#4BA83D" strokeWidth="1.66587" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              {t('footer.our_location')}
            </h3>
            <a 
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(businessName + ' ' + (officeAddress || 'Bela Industrial Estate Muzaffarpur'))}`}
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-address-link"
              title="View on Google Maps"
            >
              {officeAddress ? (
                <p className="address" style={{ whiteSpace: 'pre-line' }}>
                  {officeAddress}
                </p>
              ) : (
                <p className="address">
                  {t('footer.address_l1')}<br />
                  {t('footer.address_l2')}<br />
                  {t('footer.address_l3')}<br />
                  {t('footer.address_l4')}
                </p>
              )}
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{settings?.footerText || t('footer.copyright')}</p>
          <div className="bottom-links">
            <Link to="/privacy-policy">{t('footer.privacy_policy')}</Link>
            <span>|</span>
            <Link to="/terms">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


